import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsPhoneConfigurationRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsPhoneConfigurationRoute.tsx';
import { getServiceDeskNavigationResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { HelpCenterSettingsPhoneConfigurationEntryPoint } from './ui/phone-configuration/index.tsx';
import { navigation } from './common/constants.tsx';

export const helpCenterSettingsPhoneConfigurationRouteEntry = createEntry(
	helpCenterSettingsPhoneConfigurationRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.phone-configuration',
		layout: globalLayout,
		navigation,
		component: ErrorPagesNotFound,

		entryPoint() {
			return fg('csm_voice_configuration_page')
				? HelpCenterSettingsPhoneConfigurationEntryPoint
				: undefined;
		},

		resources: [...getServiceDeskNavigationResources()],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-help-center-settings-entries/src/helpCenterSettingsPhoneConfigurationRouteEntry.tsx',
				whichExportToUse: 'helpCenterSettingsPhoneConfigurationRouteEntry',
			},

			enabled: true,
		},
	}),
);
